import _extends from "@babel/runtime/helpers/esm/extends";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["size"];
import { useTheme } from '@emotion/react';
import { StylesAvatarVariables } from './Avatar';
import { jsx as ___EmotionJSX } from "@emotion/react";

const AvatarGroup = _ref => {
  let {
    size = 'base'
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    css: /*#__PURE__*/_css({
      display: 'flex',
      '.CK__Avatar': {
        boxShadow: `0 0 0 2px ${theme.color.light.base}`,
        marginTop: 0,
        '&:not(:first-of-type)': {
          marginLeft: -StylesAvatarVariables(theme).size[size] / 4
        }
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:AvatarGroup;")
  }, rest));
};

export default AvatarGroup;